import { Spin } from 'antd';

import { useTypedTranslation } from '~/shared/hooks';

import './loading.scss';

const Loading = () => {
  const t = useTypedTranslation(['text']);

  return (
    <div className="loading">
      <Spin />
      <span>{t('text.loading')}</span>
    </div>
  );
};

export default Loading;
